// Fonctions de logique de jeu extraites du code original

import { Player, GameScores, SetScores, ScoringType } from '../types';

/**
 * Détermine si un joueur est en situation de Game ball
 * Game ball : 10+ points ET au moins 1 point d'avance OU à 1 point de gagner avec 2 d'écart
 */
export const getGameballStatus = (player: Player, gameScores: GameScores): boolean => {
  const playerScore = gameScores[player];
  const opponentScore = gameScores[player === 'A' ? 'B' : 'A'];
  
  return (playerScore >= 10 && playerScore >= opponentScore + 1) ||
         (playerScore >= 10 && playerScore === opponentScore + 1);
};

/**
 * Détermine si un joueur est en situation de Match ball
 * Match ball : Game ball ET à 1 set de gagner le match
 */
export const getMatchballStatus = (
  player: Player, 
  gameScores: GameScores, 
  setScores: SetScores, 
  scoringType: ScoringType
): boolean => {
  const setsToWin = scoringType === 'BestOf5' ? 3 : 2;
  const playerSets = setScores[player];
  
  return getGameballStatus(player, gameScores) && (playerSets === setsToWin - 1);
};

/**
 * Vérifie si un jeu est terminé selon les règles du squash
 * Un jeu est gagné avec 11+ points et au moins 2 points d'écart
 */
export const isGameWon = (gameScores: GameScores): { isWon: boolean; winner: Player | null } => {
  const maxScore = Math.max(gameScores.A, gameScores.B);
  const minScore = Math.min(gameScores.A, gameScores.B);
  
  if (maxScore >= 11 && (maxScore - minScore) >= 2) {
    const winner = gameScores.A > gameScores.B ? 'A' : 'B';
    return { isWon: true, winner };
  }
  
  return { isWon: false, winner: null };
};

/**
 * Vérifie si un match est terminé selon les règles du squash
 * Un match est gagné avec 3 sets (BestOf5) ou 2 sets (BestOf3)
 */
export const isMatchWon = (setScores: SetScores, scoringType: ScoringType): { isWon: boolean; winner: Player | null } => {
  const setsToWin = scoringType === 'BestOf5' ? 3 : 2;
  
  if (setScores.A >= setsToWin) {
    return { isWon: true, winner: 'A' };
  }
  
  if (setScores.B >= setsToWin) {
    return { isWon: true, winner: 'B' };
  }
  
  return { isWon: false, winner: null };
};